export default __webpack_public_path__ + "static/media/decayedwebbox.fae97414.png";